import { cn } from "@/common/utils";
import CustomTypography from "@/components/Typography/CustomTypography";

export default function MbpsCell({
  value,
  className,
}: {
  value: string | undefined;
  className?: string;
}) {
  return (
    <div className={cn(className)}>
      <CustomTypography as="span" weight={"light"} case={"uppercase"}>
        {value ? <>{value} Mbps</> : "No data"}
      </CustomTypography>
    </div>
  );
}
